export default "__VITE_ASSET__CFArL7b2__"